"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "21", height: "18", viewBox: "0 0 21 18", className: "Icon nav-export", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement("path", { d: "M12.626 8.29H8.204a.632.632 0 0 0 0 1.263h4.422v6.773H2.074V1.524h10.552V8.29zm7.363.235l-2.31-2.318a.63.63 0 0 0-.446-.187h-.002a.626.626 0 0 0-.445.185.626.626 0 0 0-.185.445.627.627 0 0 0 .183.448l1.19 1.192h-4V.85A.674.674 0 0 0 13.3.178H1.4A.673.673 0 0 0 .727.85V17c0 .372.301.674.673.674h11.9a.674.674 0 0 0 .674-.674V9.553h4.064l-1.247 1.213a.632.632 0 0 0 .432 1.084h.008a.628.628 0 0 0 .44-.18l2.311-2.246a.624.624 0 0 0 .191-.448.623.623 0 0 0-.184-.451z", fill: "#777", fillRule: "evenodd" })
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/nav-export.js
// module id = 1866
// module chunks = 0